module.exports = __webpack_public_path__ + "images/emoji/paw_prints.9700435643688292e592.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/paw_prints.png
// module id = MKj4
// module chunks = 24